import { Image } from 'antd';
import da_livestock from "../../assets/img/da_livestocks_1.png";
import da_logo from "../../assets/img/da_logo_1.png";

const PanelBanner = (props) => {
  const { variant, extra, children, ...rest } = props;
  return (
    <div className={`mx-auto flex max-w-7xl items-center justify-between gap-6 px-6 py-5 ${extra}`} {...rest}>
      <div className="flex items-center gap-5">
          <Image
            src={da_logo}
            alt="Department of Agriculture"
            className="h-20 w-auto object-contain"
          />
          <div>
            <div className="mb-2 flex items-center gap-3">
              <Image
                src={da_livestock}
                alt="Department of Agriculture"
                className="h-9 w-auto object-contain"
              />
              <img
                src="/images/agriculture-icons.png"
                alt=""
                className="h-9 w-auto object-contain"
              />
            </div>

            <h1 className="text-center text-md font-bold tracking-wide text-green-800 md:text-xl">
              DIGITAL AGRICULTURE PHILIPPINES
            </h1>

            <p className="text-center mt-1 text-sm tracking-wide text-gray-700 md:text-base">
              Inclusive. Innovative. Sustainable.
            </p>
          </div>
        </div>
    </div>
  );
}

export default PanelBanner;
